export const FETCH_JSON_REQUEST = 'json/fetch/request';
export const FETCH_JSON_SUCCESS = 'json/fetch/success';
export const FETCH_JSON_FAILURE = 'json/fetch/failure';
